"use client";

import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

export default function ContactForm() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [hp, setHp] = useState(""); // honeypot field
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();

    try {
      const res = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, message, hp }),
      });

      const data = await res.json();
      if (data.ok) {
        setStatus("success");
        setName("");
        setEmail("");
        setMessage("");
        setHp("");
        setTimeout(() => setStatus("idle"), 4000);
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4 max-w-md ml-0">
      <div>
        <label className="block text-amber-400 mb-1 font-semibold">Name</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          className="w-full rounded-lg p-2 bg-gray-800 text-white border border-gray-600 focus:border-amber-400 focus:ring-amber-400"
        />
      </div>

      <div>
        <label className="block text-amber-400 mb-1 font-semibold">Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="w-full rounded-lg p-2 bg-gray-800 text-white border border-gray-600 focus:border-amber-400 focus:ring-amber-400"
        />
      </div>

      <div>
        <label className="block text-amber-400 mb-1 font-semibold">Message</label>
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          required
          rows={5}
          className="w-full rounded-lg p-2 bg-gray-800 text-white border border-gray-600 focus:border-amber-400 focus:ring-amber-400"
        />
      </div>

      {/* Honeypot hidden field */}
      <input
        type="text"
        value={hp}
        onChange={(e) => setHp(e.target.value)}
        className="hidden"
        tabIndex={-1}
        autoComplete="off"
      />

      <button
        type="submit"
        className="bg-amber-400 text-black font-bold px-4 py-2 rounded hover:bg-green-400 transition-colors"
      >
        Submit
      </button>

      <AnimatePresence>
        {status === "success" && (
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            className="text-green-400 font-semibold mt-4"
          >
            Thank you, we will be in contact shortly.
          </motion.p>
        )}
        {status === "error" && (
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            className="text-red-400 font-semibold mt-4"
          >
            Oops, something went wrong. Please try again.
          </motion.p>
        )}
      </AnimatePresence>
    </form>
  );
}
